<template>
  <VSnackbar
    v-model="showNotification"
    :timeout="-1"
    :color="notificationColor"
    location="top right"
    multi-line
  >
    <div class="d-flex align-center">
      <VIcon class="mr-3 mdi" size="28">{{ notificationIcon }}</VIcon>
      <div>
        <div class="text-subtitle-1 font-weight-bold">{{ notificationTitle }}</div>
        <div class="text-body-2">
          {{ currentNotification?.tableName || 'Table' }} - Order #{{ currentNotification?.orderNumber }}
        </div>
        <div v-if="currentNotification?.type === 'payment'" class="text-caption mt-1">
          {{ currentNotification.paidByName }} paid {{ formatPrice(currentNotification.amount) }}
          <span v-if="currentNotification.allPaid" class="text-success font-weight-bold ml-1">
            (Fully Paid)
          </span>
        </div>
        <div v-if="currentNotification?.type === 'bill_request'" class="text-caption mt-1">
          {{ currentNotification.requestedByName }} is ready to pay
        </div>
      </div>
      <VChip v-if="notificationQueue.length > 1" class="ml-3" color="white" size="x-small" variant="outlined">
        +{{ notificationQueue.length - 1 }}
      </VChip>
    </div>

    <template #actions>
      <VBtn color="white" size="small" variant="text" @click="dismissNotification">
        {{ notificationQueue.length > 1 ? 'Next' : 'Dismiss' }}
      </VBtn>
    </template>
  </VSnackbar>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue'
import { usePosEventBus } from '~/composables/usePosEventBus'

const { onTabBillRequested, onTabPaymentReceived } = usePosEventBus()

const showNotification = ref(false)
const notificationQueue = ref([])

const currentNotification = computed(() => notificationQueue.value[0] || null)

const notificationTitle = computed(() => {
  if (!currentNotification.value) return 'Tab Notification'
  return currentNotification.value.type === 'payment' ? 'Payment Received' : 'Bill Requested'
})

const notificationIcon = computed(() => {
  if (!currentNotification.value) return 'mdi-receipt'
  return currentNotification.value.type === 'payment' ? 'mdi-credit-card-check' : 'mdi-receipt-text'
})

const notificationColor = computed(() => {
  if (!currentNotification.value) return 'info'
  if (currentNotification.value.type === 'payment') {
    return currentNotification.value.allPaid ? 'success' : 'primary'
  }
  return 'info'
})

const formatPrice = (amount) => `$${Number(amount || 0).toFixed(2)}`

const dismissNotification = () => {
  notificationQueue.value.shift()
  if (notificationQueue.value.length === 0) {
    showNotification.value = false
  }
}

const handleBillRequested = (payload) => {
  console.log('[TabBillNotification] Bill requested:', payload)
  notificationQueue.value.push({
    type: 'bill_request',
    ...payload,
  })
  showNotification.value = true

  if (typeof window !== 'undefined' && 'vibrate' in navigator) {
    navigator.vibrate([200, 100, 200])
  }
}

const handlePaymentReceived = (payload) => {
  console.log('[TabBillNotification] Payment received:', payload)
  notificationQueue.value.push({
    type: 'payment',
    ...payload,
  })
  showNotification.value = true

  if (typeof window !== 'undefined' && 'vibrate' in navigator) {
    navigator.vibrate([100, 50, 100])
  }
}

let unsubscribeBill = null
let unsubscribePayment = null

onMounted(() => {
  unsubscribeBill = onTabBillRequested(handleBillRequested)
  unsubscribePayment = onTabPaymentReceived(handlePaymentReceived)
})

onUnmounted(() => {
  if (unsubscribeBill) unsubscribeBill()
  if (unsubscribePayment) unsubscribePayment()
})
</script>
